import { saga as sagaEditor } from './saga.editor';
import { saga as sagaGenerators } from './saga.generators';
import { saga as sagaGolden } from './saga.golden';
import { saga as sagaGuidance } from './saga.guidance';
import { saga as sagaHolodeck } from './saga.holodeck';
import { saga as sagaMaterials } from './saga.materials';
import { saga as sagaModels } from './saga.models';
import { saga as sagaPacks } from './saga.packs';
import { saga as sagaPlayground } from './saga.playground';
import { saga as sagaPredicates } from './saga.predicates';
import { saga as sagaProjects } from './saga.projects';
import { saga as sagaPrompt } from './saga.prompt';
import { saga as sagaTextTo3d } from './saga.text-to-3d';
import { saga as sagaTrellis } from './saga.trellis';
import { saga as sagaUnity } from './saga.unity';
import { saga as sagaValues } from './saga.values';

export const allSagas: any = {
  'sloyd.prompt': sagaPrompt,
  'sloyd.projects': sagaProjects,
  'sloyd.packs': sagaPacks,
  'sloyd.guidance': sagaGuidance,
  'sloyd.golden': sagaGolden,
  'sloyd.holodeck': sagaHolodeck,
  'sloyd.playground': sagaPlayground,
  'sloyd.editor': sagaEditor,
  'sloyd.models': sagaModels,
  'sloyd.predicates': sagaPredicates,
  'sloyd.unity': sagaUnity,
  'sloyd.generators': sagaGenerators,
  'sloyd.text-to-3d': sagaTextTo3d,
  'sloyd.values': sagaValues,
  'sloyd.materials': sagaMaterials,
  'sloyd.trellis': sagaTrellis,
};
